import React, { ReactNode } from 'react'
import "./forms.scss"

interface WrapperProps {
    children: ReactNode;
    className?: string;
    style?: React.CSSProperties;
  }
  
  export const FormWrapper: React.FC<WrapperProps> = ({ children, className, style }) => {
    return (
      <div className={className} style={style}>
        {children}
      </div>
    );
  };